import { isEnglishVoice } from '../utils/userLabel'

export function SceneChrome({
  stage,
  stageLabel,
  layout,
  usageText,
  usagePct,
  isAuthenticated,
  availableVoices,
  selectedVoiceURI,
  onVoiceChange,
  onIntegrations,
  onContext,
  onSignIn,
  onSessions,
  onNewSession,
  onUsage,
  onTickets,
}) {
  const englishVoices = availableVoices.filter(isEnglishVoice).sort((a, b) => a.name.localeCompare(b.name))
  const nonEnglishVoices = availableVoices.filter((v) => !isEnglishVoice(v)).sort((a, b) => a.name.localeCompare(b.name))
  const displayLabel = stageLabel || stage.toUpperCase()

  return (
    <div className="chrome">
      <div className={`chrome-bar ${layout === 'panel' ? 'panel-open' : ''}`}>
        <div className="nav-tl"><span className="pip" /><span className="st"><b>{displayLabel}</b></span></div>
        <div className="meter-float">
          <span>{usageText}</span>
          <span className="bar"><span className="fill" style={{ width: `${usagePct}%` }} /></span>
        </div>
        <nav className="nav-tr">
        <select
          className="voice-select"
          value={selectedVoiceURI}
          onChange={onVoiceChange}
          aria-label="Select ARIA voice"
        >
          {availableVoices.length === 0 ? <option value="">System default voice</option> : null}
          {englishVoices.length > 0 ? (
            <optgroup label="English">
              {englishVoices.map((voice) => (
                <option key={voice.voiceURI} value={voice.voiceURI}>
                  {voice.name} ({voice.lang})
                </option>
              ))}
            </optgroup>
          ) : null}
          {nonEnglishVoices.length > 0 ? (
            <optgroup label="Other languages">
              {nonEnglishVoices.map((voice) => (
                <option key={voice.voiceURI} value={voice.voiceURI}>
                  {voice.name} ({voice.lang})
                </option>
              ))}
            </optgroup>
          ) : null}
        </select>
        <button type="button" className="iconbtn" onClick={onIntegrations} aria-label="Integrations">▦</button>
        <button type="button" className="iconbtn" onClick={onContext} aria-label="GitHub context">⌘</button>
        <span className="sep" />
        {!isAuthenticated ? (
          <button type="button" onClick={onSignIn}>Sign in</button>
        ) : null}
        {isAuthenticated ? (
          <>
            <button type="button" onClick={onSessions}>Sessions</button>
            <button type="button" onClick={onNewSession}>New session</button>
          </>
        ) : null}
        <button type="button" onClick={onTickets}>Tickets</button>
        <button type="button" onClick={onUsage}>Usage</button>
        </nav>
      </div>
    </div>
  )
}
